module.exports = __webpack_public_path__ + "static/media/party-poper.b3db2fb1.svg";